import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { forwardRef } from 'react';
import { Container } from '../../primitives/Notice/components/Container.js';
const NoticeUI = ({
  children,
  variant = 'info',
  display = 'inline-block',
  ...restProps
}, ref) => _jsx(Container, {
  ref: ref,
  variant: variant,
  display: display,
  ...restProps,
  children: _jsx(Text, {
    preset: "paragraphSmall",
    children: children
  })
});
export const Notice = /*#__PURE__*/_styled(forwardRef(NoticeUI), {
  label: 'Notice',
  target: "ess3air0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5vdGljZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRRyIsImZpbGUiOiJOb3RpY2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgVGV4dCB9IGZyb20gJ0B0cmF2ZWwtZnJvbnRlbmQvY29yZSc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9Ob3RpY2UvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuY29uc3QgTm90aWNlVUkgPSAoeyBjaGlsZHJlbiwgdmFyaWFudCA9ICdpbmZvJywgZGlzcGxheSA9ICdpbmxpbmUtYmxvY2snLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSA9PiAoX2pzeChDb250YWluZXIsIHsgcmVmOiByZWYsIHZhcmlhbnQ6IHZhcmlhbnQsIGRpc3BsYXk6IGRpc3BsYXksIC4uLnJlc3RQcm9wcywgY2hpbGRyZW46IF9qc3goVGV4dCwgeyBwcmVzZXQ6IFwicGFyYWdyYXBoU21hbGxcIiwgY2hpbGRyZW46IGNoaWxkcmVuIH0pIH0pKTtcbmV4cG9ydCBjb25zdCBOb3RpY2UgPSBzdHlsZWQoZm9yd2FyZFJlZihOb3RpY2VVSSksIHtcbiAgICBsYWJlbDogJ05vdGljZScsXG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPU5vdGljZS5qcy5tYXAiXX0= */");